export { default as MolClipboardCopy } from "./ClipboardCopy.vue";
